var lastSync;

function refreshSession() {
    if (!lastSync || Date.now - lastSync > 1740000) {
        $.ajax({
            url: window.location.href,
            method: 'GET'
        });
    }
    lastSync = Date.now();
}

module.exports = {
    refreshSession: refreshSession
};